import React from 'react'
import BoxyCat from 'assets/images/banners/boxycats.gif'
import BoxyButton from 'assets/images/banners/boxyButton.png'
import { ReactComponent as BoxyFace } from 'assets/svg/boxyface.svg'
import {
  Button,
  ResponsiveFlex,
  LeftSideWrapper,
  CoolStuff,
  PleaseVisit,
  AbsoluteImg,
  ResponsiveBoxyCatWrapper,
  ResponsiveBoxyCatImg
} from './styled'

const Banner = () => {
  return (
    <ResponsiveFlex>
      <LeftSideWrapper>
        <Button>
          <BoxyFace style={{ marginRight: '4px' }} />
          <div style={{ color: '#fff' }}>BOXYCATS</div>
        </Button>
        <CoolStuff>GET A COOL PIXEL CAT NFTS</CoolStuff>
        <PleaseVisit>Visit the Boxycats website to bid and sell the nfts now.</PleaseVisit>
      </LeftSideWrapper>
      <ResponsiveBoxyCatWrapper>
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', width: '100%' }}>
          <AbsoluteImg className="click-me" src={BoxyButton} height="auto" alt="button" />
          <ResponsiveBoxyCatImg src={BoxyCat} alt="boxycat" style={{ imageRendering: 'pixelated' }} />
        </div>
      </ResponsiveBoxyCatWrapper>
    </ResponsiveFlex>
  )
}

export default Banner
